module.exports = __webpack_public_path__ + "static/media/secure-payment-powered-by-stripe.44b23ebd.jpg";